type MapOptions = google.maps.MapOptions;

export const getDistributorSettings = (mapElement: HTMLElement): MapOptions => {
  return {
    center: {
      lat: parseFloat(mapElement.dataset['initialLatitude'] ?? '0'),
      lng: parseFloat(mapElement.dataset['initialLongitude'] ?? '0')
    },
    zoom: parseFloat(mapElement.dataset['initialZoom'] ?? '3')
  }
}
